import { ApiProduct } from '@/models/api/product'
import { Either, left, right } from 'fp-ts/lib/Either'
import { Response } from 'superagent'

import { log } from '@/log'
import { ApiService } from '@/services/api/service'
import { ApiClient } from './client'

import { callWithAuth } from '@/services/auth/call-with-auth'

const namespace: string = 'product'

export class ProductService  extends ApiService {

  async userItem(id: string, query: any = {}): Promise<Either<Error, Response>> {
    try {
      const response = await callWithAuth(() => ApiClient
        .get(`/api/user-proxy/${this.appId}/product2/${id}`)
        .query(query))

      log.debug({ service: `${namespace}/userItem`, response })

      return right(response)
    } catch (error) {
      log.error({ error })

      return left(error)
    }
  }

  async commonItem(id: string, query: any = {}): Promise<Either<Error, Response>> {
    try {
      const response = await callWithAuth(() => ApiClient
        .get(`/api/common-proxy/${this.appId}/product2/${id}`)
        .query(query))

      log.debug({ service: `${namespace}/commonItem`, response })

      return right(response)
    } catch (error) {
      log.error({ error })

      return left(error)
    }
  }
  async commonItemList(query: object): Promise<Either<Error, ApiProduct[]>> {
    try {
      const response = await ApiClient
        .get(`/api/common-proxy/${this.appId}/product2`, query)

      log.debug({ service: `${namespace}/commonItem`, response })

      const products = response.body.data.map(d => new ApiProduct(d))

      return right(products)
    } catch (error) {
      log.error({ error })

      return left(error)
    }
  }
}
